import useUser from "@app/zustand/user";
import { usePreviewView } from "@app/zustand/preview-view";

/**
 * Whether this session reads as one of MAGE-X's reviewers (PT-119): a médecin of the publisher's
 * organisation, who reads and corrects their whole speciality — what the fondateur role was.
 *
 * Under the eye, the PREVIEWED account answers: « Vue médecin » on a reviewer shows what that
 * reviewer sees, their laboratory and practitioner filter included, as the server does with
 * `owner_reviewer`. Still only ever a subset of the admin's tools. A persona with no account behind
 * it (« Vue globale », the demo's own « Vue médecin ») is no reviewer.
 */
export function useIsReviewer(): boolean {
  const user = useUser((state) => state.user);
  const previewRole = usePreviewView((state) => state.previewRole);
  const previewMedecin = usePreviewView((state) => state.previewMedecin);
  if (previewRole === "medecin" && previewMedecin)
    return previewMedecin.reviewer === true;
  if (previewRole) return false;
  return (user as { reviewer?: boolean } | null)?.reviewer === true;
}
